import BackupSettings from './BackupSettings'

export default BackupSettings
